function slotGrouperDirective() {
    'ngInject';

    return {
        restrict: 'A',
        scope: true,
        link(scope, element, attrs) {
            const slots = scope.$eval(attrs.slots);
            if (!slots) {
                return;
            }
            scope.grouped_slots = [];
            for (const slot of Array.from(slots)) {
                if ((slot.time >= scope.$eval(attrs.startTime)) && (slot.time < scope.$eval(attrs.endTime))) {
                    scope.grouped_slots.push(slot);
                }
            }
            scope.has_slots = scope.grouped_slots.length > 0;
        }
    };
}

// group time slots together based on a given start time and end time
angular
    .module('BB')
    .directive('bbSlotGrouper', slotGrouperDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/slot-grouper/slot_grouper.directive.js